module.exports = __webpack_public_path__ + "fonts/ProximaNovaACond-Extrabld.6583c5cd7745bccb271bd58bdfe476bf.woff2";